import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
  scroll: Boolean,
  flex: Boolean,
  main: Boolean,
  borderT: Boolean,
  borderB: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["c-section", {
      'overflow-y-overlay': __props.scroll || __props.main,
      'flex-1': __props.flex || __props.main,
      'border-t': __props.borderT,
      'border-b': __props.borderB,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})